import type { IExtendableDto } from "../dto";
import type {
  ColumnOrderState,
  ColumnSizingState,
  GroupingState,
  SortingState,
  VisibilityState,
} from "../helpers/react-table.features";
import type { TCompanyId } from "./common.models";
import type {
  IFilterSchemaObject,
  ITypeormWhereCriteria,
} from "./filters.models";

export type TFinalSchemaInitState = {
  isViewSet: boolean;
  isRootSchemaSet: boolean;
  isProfileScopeSet: boolean;
  isFinalSchemaSet: boolean;
  isActiveViewResolved: boolean;
};
export interface IPageSchema {
  filtersCriteria?: ITypeormWhereCriteria<IExtendableDto>; // TODO check usage of this prop
  filtersSchema?: IFilterSchemaObject;
  columnsOrder?: ColumnOrderState;
  columnsGrouping?: GroupingState;
  columnsSorting?: SortingState;
  columnsVisibility?: VisibilityState;
  columnsSizing?: ColumnSizingState;
}
export const pageSchemaPropNames = [
  "filtersCriteria",
  "filtersSchema",
  "columnsOrder",
  "columnsGrouping",
  "columnsSorting",
  "columnsVisibility",
  "columnsSizing",
];

export type TValidFinalSchema = Required<IPageSchema>;
export type TCompanyFinalSchemaKey = `${TCompanyId}_lastFinalSchema`;
export type TCompanyReportColumnsSizingKey =
  `${TCompanyId}_reportColumnsSizing`;
